/* eslint-disable max-len */
import Keycloak from 'keycloak-js';
import env from '../config/env';
import ApiService from './ApiService';
import { RedirectType } from '../pages/Invite/redirectType.enum';
import localStorageFacade, { LocalStorageKeys } from '../utils/localStorageFacade';

const existsByEmail = (email) => ApiService.httpClient.get(`${env.api.url}/v1/users`, { params: { email } })
  .then((response) => (response.status === 200))
  // eslint-disable-next-line
  .catch((e) => console.error(e));

const kc = new Keycloak(env.keycloak);

const doInit = kc.init;

const loginByGoogle = () => {
  doInit()
    .then(kc.login({ redirectUri: `${window.location.href}`.replace(RedirectType.LOGOUT, RedirectType.GOOGLE), idpHint: 'google', prompt: 'login' }));
};

const updateToken = (successCallback) => kc.updateToken(30)
  .then(successCallback)
  .catch(loginByGoogle);

const authenticateBySso = () => new Promise((resolve) => {
  doInit({
    ...env.keycloak.init,
  })
    .then((isAuthenticated) => {
      if (!isAuthenticated) {
        window.location.href = `${window.location.href}`.replace(`&redirect=${RedirectType.GOOGLE}`, '');
      }
      kc.onTokenExpired = () => updateToken();
      return resolve({
        accessToken: kc.token,
      });
    });
});

const removeSsoIfPresent = (redirectUrl) => {
  doInit({
    ...env.keycloak.init,
  })
    .then((isAuthenticated) => {
      if (isAuthenticated) {
        kc.logout({ redirectUri: redirectUrl });
      }
      window.location.href = redirectUrl;
    });
};

const fetchLoggedUser = () => ApiService.httpClient.get(
  `${env.api.url}/v0/persons/me`,
  {
    headers: {
      Authorization: `Bearer ${localStorageFacade.get(LocalStorageKeys.AUTH_TOKEN)}`,
    },
  },
);

const UserService = {
  existsByEmail,
  loginByGoogle,
  authenticateBySso,
  removeSsoIfPresent,
  fetchLoggedUser,
};

export default UserService;
